(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
// Sticky bar — появляется только когда пользователь проскроллил мимо основной кнопки
var sticky = document.getElementById('wppSticky');
var trigger = document.getElementById('wppBuyBox');
if (sticky && trigger && 'IntersectionObserver' in window) {
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      sticky.classList.toggle('is-visible', !entry.isIntersecting);
    });
  }, { rootMargin: '0px 0px -10% 0px' });
  io.observe(trigger);
}

    // Buy Now — add to cart, then go straight to checkout (bypasses cart page)
    document.querySelectorAll('.wpp-buy-now').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var variantId = btn.getAttribute('data-variant-id');
        var originalText = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Add to cart failed');
            window.location.href = '/checkout';
          })
          .catch(function () {
            btn.disabled = false;
            btn.textContent = originalText;
            alert('Something went wrong. Please try again.');
          });
      });
    });

    // FAQ accordion
    var items = document.querySelectorAll('.wpp-faq-item');
    items.forEach(function (item) {
      var btn = item.querySelector('.wpp-faq-item__btn');
      var panel = item.querySelector('.wpp-faq-item__panel');
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        items.forEach(function (other) {
          if (other !== item) {
            other.classList.remove('is-open');
            other.querySelector('.wpp-faq-item__panel').style.maxHeight = '';
          }
        });
        if (isOpen) {
          item.classList.remove('is-open');
          panel.style.maxHeight = '';
        } else {
          item.classList.add('is-open');
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    });
  });

  // Add-only buttons: добавляют в корзину и сразу переносят на страницу корзины
  document.querySelectorAll('.wpp-add-only').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          window.location.href = '/cart';
        })
        .catch(function () {
          btn.disabled = false;
          alert('Something went wrong. Please try again.');
        });
    });
  });
})();
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var checkoutBtn = document.querySelector('.cart-page__summary button[name="checkout"]');
    if (!checkoutBtn || document.querySelector('.wpp-cart-continue')) return;

    var link = document.createElement('a');
    link.href = '/products/wisty-nfc-card';
    link.className = 'wpp-cart-continue';
    link.textContent = 'Continue shopping';

    checkoutBtn.insertAdjacentElement('afterend', link);
  });
})();
document.addEventListener('DOMContentLoaded', function () {
  var ratingLine = document.getElementById('wppRatingLine');
  if (!ratingLine) return;

  ratingLine.addEventListener('click', function () {
    var target = document.getElementById('wppReviews');
    if (!target) return;

    var scroller = document.querySelector('.page-wrapper') || window;
    var targetTop = target.getBoundingClientRect().top;

    if (scroller === window) {
      window.scrollBy({ top: targetTop - 24, behavior: 'smooth' });
    } else {
      var scrollerTop = scroller.getBoundingClientRect ? scroller.getBoundingClientRect().top : 0;
      scroller.scrollTo({ top: scroller.scrollTop + (targetTop - scrollerTop) - 24, behavior: 'smooth' });
    }
  });
});